var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandColorGateIo = function SvgBrandColorGateIo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.5C8.9624 17.5 6.5 15.0376 6.5 12C6.5 8.9624 8.9624 6.5 12 6.5V2C6.4768 2 2 6.4768 2 12C2 17.5224 6.4768 22 12 22C17.5224 22 22 17.5232 22 12H17.5C17.5 15.0376 15.0376 17.5 12 17.5Z",
    fill: "#2354E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12H17.5V6.5H12V12Z",
    fill: "#17E6A1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandColorGateIo);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMTcuNUM4Ljk2MjQgMTcuNSA2LjUgMTUuMDM3NiA2LjUgMTJDNi41IDguOTYyNCA4Ljk2MjQgNi41IDEyIDYuNVYyQzYuNDc2OCAyIDIgNi40NzY4IDIgMTJDMiAxNy41MjI0IDYuNDc2OCAyMiAxMiAyMkMxNy41MjI0IDIyIDIyIDE3LjUyMzIgMjIgMTJIMTcuNUMxNy41IDE1LjAzNzYgMTUuMDM3NiAxNy41IDEyIDE3LjVaIiBmaWxsPSIjMjM1NEU2Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMTJIMTcuNVY2LjVIMTJWMTJaIiBmaWxsPSIjMTdFNkExIi8+Cjwvc3ZnPgo=";